export default __webpack_public_path__ + "static/media/HomeHair.636cd695.png";